import { PdfImportJobDocument } from "@/generated/graphql";
import { useQuery } from "@apollo/client/react";
import { useEffect } from "react";

/**
 * Polls a PDF import job every 2s until it reaches a terminal state (done | failed), then stops.
 * Pass `null` before a job exists (the query is skipped).
 */
export function usePdfImportJob(id: string | null) {
  const { data, stopPolling } = useQuery(PdfImportJobDocument, {
    variables: { id: id ?? "" },
    skip: !id,
    pollInterval: 2000,
    fetchPolicy: "network-only",
  });

  const job = data?.pdfImportJob ?? null;

  useEffect(() => {
    if (!id || job?.status === "done" || job?.status === "failed") stopPolling();
  }, [id, job?.status, stopPolling]);

  return job;
}
